import { genericActions } from "../_helpers/ActionErrorWrapper";

import { DevicesService } from "../_services/DevicesService";
import { DistributorDeviceMapper } from "../_mappers/DistributorDeviceMapper";

export const DevicesActions = {
    getDeviceByBluetoothId,
};

function getDeviceByBluetoothId(bluetoothId) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const serverDevices = await DevicesService.getDeviceByBluetoothId(bluetoothId);
            return DistributorDeviceMapper.allServerToLocal(serverDevices);
        }
    };
}